import { AnimationEvent } from '@angular/animations';
import { ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Inject, Output } from '@angular/core';
import { Cms, ICarDetails, ILink } from '@impact/data';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@impactdk/ngx-overlay';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { closeLightIcon } from '../../../../icons';
import { SidePanelService } from '../../../side-panel/side-panel.service';
import { slideInTop } from '../../../utils/animations/slide.animations';
import { UsedCarPageSections } from '../../used-car.models';
import { UsedCarService } from '../../used-car.service';

@Component({
    selector: 'app-used-car-gallery-cta',
    templateUrl: './used-car-gallery-cta.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [slideInTop],
})
export class UsedCarGalleryCtaComponent {
    @HostBinding('class') class = 'app-used-car-gallery-cta';
    car$: Observable<ICarDetails>;
    link$: Observable<Cms.Link | undefined>;
    closeLightIcon = closeLightIcon;
    animationState = 'enter';
    @Output() readyToRemove: EventEmitter<void> = new EventEmitter();
    constructor(
        usedCarService: UsedCarService,
        @Inject(IMPACT_OVERLAY_DATA) public data: any,
        private sidePanelService: SidePanelService,
        private scroller: ViewportScroller,
        private overlayRef: ImpactOverlayRef,
    ) {
        this.car$ = usedCarService.carDetails$;
        this.link$ = usedCarService.pageData$.pipe(map((d) => d?.galleryCTALink));
    }

    close() {
        this.animationState = 'leave';
    }

    onAnimationEvent(event: AnimationEvent) {
        if (event.fromState === 'enter') {
            this.readyToRemove.emit();
        }
    }

    goToFinancing() {
        this.closeGallery();
        this.scroller.scrollToAnchor(UsedCarPageSections.INSURANCE);
    }

    openTestDriveSidePanel() {
        this.closeGallery();
        this.sidePanelService.showBookUsedCarTestDriveSidePanel(this.car$);
    }

    onLinkClick() {
        this.closeGallery();
    }

    private closeGallery() {
        this.overlayRef.close();
    }
}
